import * as React from 'react';
import { FooterWrapper, ListFooterLink } from './styled';
import { Link } from 'react-router-dom';

import {FormattedMessage} from 'react-intl';


const Footer:React.FunctionComponent = () => {
  
    return <FooterWrapper>
      {/* Suppression de l'alcool .... */}
      <ListFooterLink className="right">
        <li><a href="http://www.meemento.com" target="_blank"><FormattedMessage id="global_txt_footer_editedby"/></a></li>
        <li><a href="http://www.livstick.com/mc/ml.pdf" target="_blank"><FormattedMessage id="global_txt_footer_legal"/></a></li>
        <li><a href="http://www.livstick.com/mc/cgu.pdf" target="_blank"><FormattedMessage id="global_txt_footer_tandc"/></a></li>
        <li><a href="http://www.livstick.com/mc/pc.pdf" target="_blank"><FormattedMessage id="global_txt_footer_privacy"/></a></li>
      </ListFooterLink>
      
    </FooterWrapper>;
}

export default Footer;